import type { AppRouter } from '@functions/src/common/api/app-router';
import { getTrpcUrl } from '@pop-common/constants/url/get-trpc-url';
import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';

import { baseURL } from '../environments/config';

export const trpc = createTRPCProxyClient<AppRouter>({
  links: [
    httpBatchLink({
      url: getTrpcUrl({ baseURL }),
    }),
  ],
});
